export let calendarModuleSelectedCalendarsCollectorDescription = "v$SuGb";
export default {calendarModuleSelectedCalendarsCollectorDescription};